import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RechargeService {

  api = environment.apiEndPoint;

  constructor(private http: HttpClient) {}

  getPaymentPlans() {
    return this.http.get(this.api + '/Recharge');
  }

  recharge(data: any) {
    return this.http.post(this.api + '/Recharge', data);
  }

  getProductsList() {
    return this.http.get(this.api + '/BuyProduct');
  }

  purchseProduct(id: any) {
    return this.http.post(this.api + '/BuyProduct', {productId: id});
  }

  rechargeHistory(pageIndex: any) {
    return this.http.get(this.api+ '/Recharge/GetAll?PageIdex='+ pageIndex);
  }

  transactionHistory(pageIndex: any, data: any, isMetaData: boolean) {
    data.isMetaData = isMetaData;
    return this.http.get(this.api +'/Trans/GetAll?PageIdex='+pageIndex, {params:data});
  }

  transactionSearchSD() {
    return this.http.get(this.api + '/Trans/GetSearchSD');
  }

  getTransactionCsv(data: any) {
    return this.http.get(this.api+'/Trans/GetCsv', {params: data, responseType: 'blob'});
  }

  addBalance(data: any) {
    return this.http.put(this.api + "/Business/AddBalance", data);
  }

  deductBalance(data: any) {
    return this.http.put(this.api + "/Business/DeductBalance", data);
  }

  addMask(data: any) {
    return this.http.post(this.api + "/Mask", data);
  }

  updateMask(data: any) {
    return this.http.put(this.api + "/Mask", data);
  }
}
